import loadable from "@loadable/component";
import CreateIcon from "../../Icons/CreateIcon";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../customHooks/usePostHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useSearchParams } from "react-router-dom";
import useGetHook from "../../customHooks/useGetHook";
import useTenantGetHook from "../../customHooks/useTenantControlGetHook";
import { getKey } from "../../helpers/sessionKey";
const CreateMerchantInvoiceComponent = loadable(
  () => import("../../components/MerchantInvoice/CreateMerchantInvoice")
);
const CreateMerchantInvoice = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["Merchant Invoice"],
    navigateURL: "/",
  });
  const { mutateAsync: draftSaveAsync, isPostLoading: isDraftSaveLoading } =
    usePostHook({
      queryKey: ["orders"],
      navigateURL: "",
    });

  const { data: statusData } = useGetHook({
    queryKey: [`status`],
    url: `${APIS.ORDER_STATUS}`,
    params: {
      is_final_state: true,
      is_active: true,
    },
  });
  const [searchParams, setSearchParms] = useSearchParams();

  const decodeItem = (item: string) => {
    const parts = item.split("%3A");
    const id = parts[0];

    const fields: Record<string, number> = {};
    for (let i = 1; i < parts.length; i++) {
      const [key, value] = parts[i].split("%3D");
      fields[key] = Number(value);
    }

    return {
      id,
      deliver_charge: fields.delivery_charge ?? 0,
      piece: fields.piece ?? 0,
      weight: fields.weight ?? 0,
    };
  };

  const parseCombinedOrders = (searchParams) => {
    const editedRaw = searchParams.get("editedOrders");
    const selectedRaw = searchParams.get("selectedItems");

    const updatesMap = new Map();

    // --- 1. Parse selectedItems first ---
    if (selectedRaw) {
      selectedRaw.split(",").forEach((entry) => {
        const item = decodeItem(entry);

        // Initialize map entry
        if (!updatesMap.has(item.id)) {
          updatesMap.set(item.id, { id: item.id });
        }

        updatesMap.get(item.id).delivery_charge = item.deliver_charge ?? 0;
        updatesMap.get(item.id).piece = item.piece ?? 0;
        updatesMap.get(item.id).weight = item.weight ?? 0;
      });
    }

    if (editedRaw) {
      editedRaw.split(",").forEach((entry) => {
        // Format: id:field=value
        const [idField, value] = entry.split("=");
        const [id, field] = idField.split(":");

        // Ensure entry exists in the map
        if (!updatesMap.has(id)) {
          updatesMap.set(id, { id });
        }

        // Overwrite with editedOrders (takes priority)
        updatesMap.get(id)[field] = Number(value);
      });
    }

    return Array.from(updatesMap.values());
  };

  const parseEditedOrders = (searchParams) => {
    const editedRaw = searchParams.get("editedOrders");
    const updatesMap = new Map();
    if (editedRaw) {
      editedRaw
        .split(",")
        .filter((entry) => entry && entry !== "null")
        .forEach((entry) => {
          const [idField, value] = entry.split("=");
          if (!idField || !value) return;

          const [id, field] = idField.split(":");
          if (!id || !field) return;

          if (!updatesMap.has(id)) {
            updatesMap.set(id, { id });
          }
          updatesMap.get(id)[field] = Number(value);
        });
    }

    return Array.from(updatesMap.values());
  };

  const handleCreate = async (user: any, values: any, setError: any) => {
    const dataToPost = parseCombinedOrders(searchParams);
    const url = `${APIS.MERCHANT_INVOICE}`;
    const dates = values?.created__range
      ? values?.created__range
          .split(",")
          .map((datetime) => datetime.split("T")[0])
      : null;

    let formData = {
      user: user,
      orders: dataToPost,
      date_range: dates,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  const handleSaveDraft = async () => {
    const dataToPost = parseEditedOrders(searchParams);
    const url = `${APIS.INVOICE_ORDER}update/`;
    let formData = {
      orders: dataToPost,
    };
    try {
      const res = await draftSaveAsync({ url, formData, setError: () => {} });
      // if (res?.status === 200) {
      //   searchParams.delete("editedOrders");
      //   setSearchParms(searchParams);
      // }
    } catch (err) {
      console.error(err);
    }
  };

  const { data, isLoading: isPermissionListLoading } = useTenantGetHook({
    queryKey: [`permission`],
    url: `${APIS.PERMISSION}`,
    params: {},
  });

  const permissionsLists: any = data && data?.custom_permissions;
  const defaultBranch = JSON.parse(getKey("default-branch") || "");
  const isSuperUser = getKey("is_superuser");

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Merchant Statement
        </span>
      </div>
      <CreateMerchantInvoiceComponent
        handleCreate={handleCreate}
        isLoading={isPostLoading}
        statusData={statusData}
        userPermissions={permissionsLists}
        isDraftSaveLoading={isDraftSaveLoading}
        handleSaveDraft={handleSaveDraft}
        defaultBranch={defaultBranch}
        isSuperUser={isSuperUser}
      />
    </>
  );
};

export default CreateMerchantInvoice;
